import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Check, Copy } from "lucide-react";

export const WalletBox = ({ wallet }) => {
  const [copied, setCopied] = useState(false);
  if (!wallet) return <div className="wallet-box" data-testid="cold-wallet-instructions"><span>COLD-WALLET DESTINATION</span><small data-testid="wallet-not-configured">No verified wallet is configured yet. Payments are paused until an operator adds one.</small></div>;
  const copy = async () => { await navigator.clipboard.writeText(wallet.address); setCopied(true); setTimeout(() => setCopied(false), 1800); };
  return <div className="wallet-box wallet-live" data-testid="cold-wallet-instructions">
    <div className="wallet-qr" data-testid="wallet-qr-code"><QRCodeSVG value={wallet.address} size={116} bgColor="#e2f5ea" fgColor="#031109" marginSize={2}/></div>
    <div className="wallet-info">
      <span>SEND {wallet.currency} ON {wallet.network.toUpperCase()} ONLY</span>
      <code data-testid="wallet-address">{wallet.address}</code>
      <button type="button" className="wallet-copy" onClick={copy} data-testid="wallet-copy-button">{copied ? <><Check size={13}/> Copied</> : <><Copy size={13}/> Copy address</>}</button>
      <small>Membership is <b>$30 = 30 USDT</b> (1 USD = 1 USDT). Send the exact amount in {wallet.currency}. Double-check the first and last 6 characters after pasting — clipboard malware can swap addresses.</small>
    </div>
  </div>;
};
